export const INIT = "INIT";
export const GET_LICENSE_STATUS = "GET_LICENSE_STATUS";
export const GET_LICENSE_STATUS_COMPACT = "GET_LICENSE_STATUS_COMPACT";

export const SETTINGS_SET_VALUE = "SETTINGS_SET_VALUE";
export const SETTINGS_GET_VALUE = "SETTINGS_GET_VALUE";
export const SETTINGS_GET_PRICE_TYPES = "SETTINGS_GET_PRICE_TYPES";
export const SETTINGS_SET_BASIC_SETUP_LOCALE = "SETTINGS_SET_BASIC_SETUP_LOCALE";
export const SETTINGS_GET_LOCALE = "SETTINGS_GET_LOCALE";
export const SETTINGS_GET_FORMULA_NAME = "SETTINGS_GET_FORMULA_NAME";
export const SETTINGS_GET_FORMULA_CODE = "SETTINGS_GET_FORMULA_CODE";
export const SETTINGS_GET_SEARCH_PANEL_BASE = "SETTINGS_GET_SEARCH_PANEL_BASE";
export const SETTINGS_GET_SEARCH_PANEL_BIPP = "SETTINGS_GET_SEARCH_PANEL_BIPP";
export const SETTINGS_GET_SEARCH_PANEL_PRODUCT = "SETTINGS_GET_SEARCH_PANEL_PRODUCT";
export const SETTINGS_GET_SPECTRO_ENABLED = "SETTINGS_GET_SPECTRO_ENABLED";
export const SETTINGS_GET_TABS_ENABLED = "SETTINGS_GET_TABS_ENABLED";
export const SETTINGS_GET_TINTOMETRIC_SYSTEM = "SETTINGS_GET_TINTOMETRIC_SYSTEM";
export const SETTINGS_GET_UFI_CODE_BASE_VALIDATION = "SETTINGS_GET_UFI_CODE_BASE_VALIDATION";
export const SETTINGS_GET_UFI_CODE_LOGIC = "SETTINGS_GET_UFI_CODE_LOGIC";
export const SETTINGS_GET_VISIBLE_UNITS = "SETTINGS_GET_VISIBLE_UNITS";
export const SETTINGS_GET_CUSTOM_CAN_OPTION = "SETTINGS_GET_CUSTOM_CAN_OPTION";
export const SETTINGS_GET_SEARCH_PANEL_QUICK_SELECT = "SETTINGS_GET_SEARCH_PANEL_QUICK_SELECT";
export const SETTINGS_GET_BLEND_FORMULA_AND_CODE = "SETTINGS_GET_BLEND_FORMULA_AND_CODE";
export const SETTINGS_GET_POSITION_AND_LOAD_BANNER_LIST = "SETTINGS_GET_POSITION_AND_LOAD_BANNER_LIST";
export const SETTINGS_GET_COLOR_TAB_COMPATIBLE_ONLY = "SETTINGS_GET_COLOR_TAB_COMPATIBLE_ONLY";
export const SETTINGS_GET_COLOR_TAB_ORDER_BY = "SETTINGS_GET_COLOR_TAB_ORDER_BY";
export const SETTINGS_GET_COLOR_TAB_ROW_COUNT = "SETTINGS_GET_COLOR_TAB_ROW_COUNT";
export const SETTINGS_GET_COLOR_TAB_NOTE_ICONS = "SETTINGS_GET_COLOR_TAB_NOTE_ICONS";
export const SETTINGS_GET_LOCK_COMPUTER = "SETTINGS_GET_LOCK_COMPUTER";
export const SETTINGS_GET_NAVIGATION_ITEMS = "SETTINGS_GET_NAVIGATION_ITEMS";
export const SETTINGS_GET_ORDER_SEARCH_ITEMS = "SETTINGS_GET_ORDER_SEARCH_ITEMS";
export const SETTINGS_SET_QUICK_SELECT = "SETTINGS_SET_QUICK_SELECT";
export const SETTINGS_GET_INTERGAMMA_MACHINE_SORTING_ORDERS = "SETTINGS_GET_INTERGAMMA_MACHINE_SORTING_ORDERS";

//intergamma
export const INTERGAMMA_SET_ACTIVE_DATABASE = "INTERGAMMA_SET_ACTIVE_DATABASE";
export const INTERGAMMA_GET_ACTIVE_DATABASE = "INTERGAMMA_GET_ACTIVE_DATABASE";
export const INTERGAMMA_SET_DATABASE_AND_OPEN_FANDECK_STEP = "INTERGAMMA_SET_DATABASE_AND_OPEN_FANDECK_STEP";
export const INTERGAMMA_GET_DATABASE_AND_OPEN_FANDECK_STEP = "INTERGAMMA_GET_DATABASE_AND_OPEN_FANDECK_STEP";
export const INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE = "INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_BARCODE";
export const INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_BARCODE = "INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_BARCODE";
export const INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE = "INTERGAMMA_SET_ACTIVE_DATABASE_AFTER_CIF_BARCODE";
export const INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_CIF_BARCODE = "INTERGAMMA_GET_ACTIVE_DATABASE_AFTER_CIF_BARCODE";

export const INTERGAMMA_RELOAD_COLORS = "INTERGAMMA_RELOAD_COLORS";
export const INTERGAMMA_RELOAD_FANDECKS = "INTERGAMMA_RELOAD_FANDECKS";
export const INTERGAMMA_GET_PRODUCTS_BY_PARAMS = "INTERGAMMA_GET_PRODUCTS_BY_PARAMS";
export const INTERGAMMA_GET_ALL_CUSTOMERS = "INTERGAMMA_GET_ALL_CUSTOMERS";
export const INTERGAMMA_GET_COLORANT_PACKAGE_BY_BARCODE = "INTERGAMMA_GET_COLORANT_PACKAGE_BY_BARCODE";
export const INTERGAMMA_GET_PRODUCT_IMAGE = "INTERGAMMA_GET_PRODUCT_IMAGE";

export const INTERGAMMA_MACHINE_GET_PRODUCT_IMAGE = "INTERGAMMA_MACHINE_GET_PRODUCT_IMAGE";
export const INTERGAMMA_MACHINE_ORDER_DETAIL = "INTERGAMMA_MACHINE_ORDER_DETAIL";
export const INTERGAMMA_MACHINE_ORDER_DETAIL_RELOAD = "INTERGAMMA_MACHINE_ORDER_DETAIL_RELOAD";

export const INTERGAMMA_MACHINE_SET_CANCELED_ORDER_STATUS = "INTERGAMMA_MACHINE_SET_CANCELED_ORDER_STATUS";
export const INTERGAMMA_MACHINE_SET_DISPENSE_LEVEL = "INTERGAMMA_MACHINE_SET_DISPENSE_LEVEL";
export const INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE = "INTERGAMMA_MACHINE_SET_ACTIVE_DATABASE";
export const INTERGAMMA_MACHINE_GET_ACTIVE_DATABASE = "INTERGAMMA_MACHINE_GET_ACTIVE_DATABASE";

export const INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID = "INTERGAMMA_GET_DISPENSED_ORDERS_BY_CUSTOMER_ID";

export const INTERGAMMA_RECALCULATE_FORMULA = "INTERGAMMA_RECALCULATE_FORMULA";

//init
export const INIT_GLOBAL_SERVER_CONFIGURATION = "INIT_GLOBAL_SERVER_CONFIGURATION";
export const INIT_GLOBAL_INITIAL_DATA = "INIT_GLOBAL_INITIAL_DATA";
export const INIT_GLOBAL_LAST_DISPENSED_FORMULAS = "INIT_GLOBAL_LAST_DISPENSED_FORMULAS";
export const INIT_GLOBAL_FAVORITE_FORMULAS = "INIT_GLOBAL_FAVORITE_FORMULAS";
export const INIT_GLOBAL_ALL_SERVER_COLORANTS = "INIT_GLOBAL_ALL_SERVER_COLORANTS";
export const INIT_GLOBAL_COLORANTS = "INIT_GLOBAL_COLORANTS";
export const INIT_GLOBAL_ALL_PRODUCTS = "INIT_GLOBAL_ALL_PRODUCTS";
export const INIT_GLOBAL_ALL_PRODUCTS_SIMPLE = "INIT_GLOBAL_ALL_PRODUCTS_SIMPLE";
export const INIT_GLOBAL_ALL_FANDECKS = "INIT_GLOBAL_ALL_FANDECKS";
export const INIT_GLOBAL_MARGINS = "INIT_GLOBAL_MARGINS";
export const INIT_GLOBAL_SETTING_OPTIONS = "INIT_GLOBAL_SETTING_OPTIONS";
export const INIT_GLOBAL_USER_SETTINGS = "INIT_GLOBAL_USER_SETTINGS";
export const INIT_GLOBAL_GET_ALL_UNITS = "INIT_GLOBAL_GET_ALL_UNITS";
export const INIT_DRIVER_CONFIGURATION = "INIT_DRIVER_CONFIGURATION";
export const INIT_MACHINE_CONFIGURATION = "INIT_MACHINE_CONFIGURATION";
export const INIT_SPECTRO_CONFIGURATION = "INIT_SPECTRO_CONFIGURATION";
export const INIT_MACHINE_IS_BUSY = "INIT_MACHINE_IS_BUSY";
export const INIT_MACHINE_INFO = "INIT_MACHINE_INFO";
export const INIT_MACHINE_DEVICES = "INIT_MACHINE_DEVICES";
export const INIT_MACHINE_CAN_BATCH_NUMBERS = "INIT_MACHINE_CAN_BATCH_NUMBERS";
export const INIT_MACHINE_CANISTERS = "INIT_MACHINE_CANISTERS";
export const INIT_MACHINE_CHANNELS = "INIT_MACHINE_CHANNELS";
export const INIT_MACHINE_ERRORS = "INIT_MACHINE_ERRORS";
export const INIT_MACHINE_SENSORS = "INIT_MACHINE_SENSORS";
export const INIT_MACHINE_HISTORY = "INIT_MACHINE_HISTORY";
export const INIT_RCC_COLORANTS = "INIT_RCC_COLORANTS";
export const INIT_MACHINE_UNITS = "INIT_MACHINE_UNITS";
export const INIT_MACHINE_MESSAGES = "INIT_MACHINE_MESSAGES";
export const INIT_MACHINE_PURGE_RULES = "INIT_MACHINE_PURGE_RULES";
export const INIT_MACHINE_AUTOTASKS = "INIT_MACHINE_AUTOTASKS";
export const INIT_MACHINE_AUTOTASK_TYPES = "INIT_MACHINE_AUTOTASK_TYPES";
export const INIT_GLOBAL_TO_DISPENSE_GET_ORDERS = "INIT_GLOBAL_TO_DISPENSE_GET_ORDERS";
export const INIT_GLOBAL_DATABASES_LIST = "INIT_GLOBAL_DATABASES_LIST";
export const INIT_GLOBAL_COMPATIBLE_SERVERS = "INIT_GLOBAL_COMPATIBLE_SERVERS";
export const INIT_PRINTER_PRINTERS_LIST = "INIT_PRINTER_PRINTERS_LIST";
export const INIT_PRINTER_TEMPLATES_LIST = "INIT_PRINTER_TEMPLATES_LIST";

export const LOG_IN_AND_CHANGE_USER = "LOG_IN_AND_CHANGE_USER";
export const LOG_OUT_AND_CHANGE_USER = "LOG_OUT_AND_CHANGE_USER";
export const LOG_OUT_AND_AUTOLOGIN_USER = "LOG_OUT_AND_AUTOLOGIN_USER";
export const SEARCH_GLOBAL_FORMULAS_WITH_OFFSET = "SEARCH_COLORS_WITH_OFFSET";
export const GET_DISPENSING_PRODUCT_IMAGE = "GET_DISPENSING_PRODUCT_IMAGE";
export const GET_LIGHT_TO_DISPENSE_PRODUCT_IMAGE = "GET_LIGHT_TO_DISPENSE_PRODUCT_IMAGE";
export const MACHINE_HISTORY_REFILLS_WITH_OFFSET = "MACHINE_HISTORY_REFILLS_WITH_OFFSET";
export const GET_PRODUCTS_WITH_AUTOSELECT = "GET_PRODUCTS_WITH_AUTOSELECT";
export const GET_FANDECKS_WITH_AUTOSELECT = "GET_FANDECKS_WITH_AUTOSELECT";
export const GET_FANDECKS_WITH_OFFSET = "GET_FANDECKS_WITH_OFFSET";
export const GET_COLORS_BY_PARAMS_INIT = "GET_COLORS_BY_PARAMS_INIT";
export const GET_COLORS_WITH_OFFSET = "GET_COLORS_WITH_OFFSET";
export const GET_COLORS_WITH_AUTOSELECT = "GET_COLORS_WITH_AUTOSELECT";
export const GET_COLOR_CODES_BY_PARAMS_INIT = "GET_COLOR_CODES_BY_PARAMS_INIT";
export const GET_COLOR_CODES_BY_PARAMS = "GET_COLOR_CODES_BY_PARAMS";
export const GET_COLOR_CODES_WITH_OFFSET = "GET_COLOR_CODES_WITH_OFFSET";
export const GET_BASES_BY_PARAMS = "GET_BASES_BY_PARAMS";
export const GET_BASES_WITH_OFFSET = "GET_BASES_WITH_OFFSET";
export const GET_BASES_WITH_AUTOSELECT = "GET_BASES_WITH_AUTOSELECT";
export const GET_BIPP_BY_PARAMS = "GET_BIPP_BY_PARAMS";
export const GET_BIPP_WITH_OFFSET = "GET_BIPP_WITH_OFFSET";
export const GET_BIPP_WITH_AUTOSELECT = "GET_BIPP_WITH_AUTOSELECT";
export const BROWSE_CIF_WITH_OFFSET = "BROWSE_CIF_WITH_OFFSET";
export const NAVIGATION_GET_CALCULATED_FORMULA = "NAVIGATION_GET_CALCULATED_FORMULA";
export const SEARCH_PANEL_GET_CALCULATED_FORMULA = "SEARCH_PANEL_GET_CALCULATED_FORMULA";
export const GET_FORMULA_META_AND_DISPENSE = "GET_FORMULA_META_AND_DISPENSE";
export const NAVIGATION_GET_FORMULA_META_AND_PRINT_DATA = "NAVIGATION_GET_FORMULA_META_AND_PRINT_DATA";
export const GET_CUSTOMERS_WITH_OFFSET = "GET_CUSTOMERS_WITH_OFFSET";
export const FILTERING_GET_DEFAULT_PRODUCT_LIST = "FILTERING_GET_DEFAULT_PRODUCT_LIST";
export const FILTERING_GET_DEFAULT_FANDECK_LIST = "FILTERING_GET_DEFAULT_FANDECK_LIST";
export const FILTERING_GET_LOCAL_FANDECK_LIST = "FILTERING_GET_LOCAL_FANDECK_LIST";
export const FILTERING_GET_DEFAULT_FORMULA_LIST = "FILTERING_GET_DEFAULT_FORMULA_LIST";
export const FILTERING_GET_LOCAL_FORMULA_LIST = "FILTERING_GET_LOCAL_FORMULA_LIST";
export const FILTERING_GET_DEFAULT_FORMULA_CODE_LIST = "FILTERING_GET_DEFAULT_FORMULA_CODE_LIST";
export const FILTERING_GET_LOCAL_FORMULA_CODE_LIST = "FILTERING_GET_LOCAL_FORMULA_CODE_LIST";
export const FILTERING_GET_DEFAULT_BASE_LIST = "FILTERING_GET_DEFAULT_BASE_LIST";
export const FILTERING_GET_DEFAULT_PACKAGE_LIST = "FILTERING_GET_DEFAULT_PACKAGE_LIST";
export const FILTERING_GET_DEFAULT_CUSTOMER_LIST = "FILTERING_GET_DEFAULT_CUSTOMER_LIST";
export const LIGHT_ADD_CUSTOMER = "LIGHT_ADD_CUSTOMER";
export const CUSTOM_TAB_LOAD_BASE_LIST = "CUSTOM_TAB_LOAD_BASE_LIST";
export const CUSTOM_TAB_LOAD_MASTER_PRODUCT_LIST = "CUSTOM_TAB_LOAD_MASTER_PRODUCT_LIST";
export const CUSTOM_TAB_GET_PACKAGES_BY_PARAMS = "CUSTOM_TAB_GET_PACKAGES_BY_PARAMS";
export const MACHINE_CONNECTION_TEST = "MACHINE_CONNECTION_TEST";
export const MACHINE_VALIDATE_QUICK_DISPENSE_FORMULA = "MACHINE_VALIDATE_QUICK_DISPENSE_FORMULA";
export const MACHINE_VALIDATE_FORMULA_AND_LOAD_MANUAL = "MACHINE_VALIDATE_FORMULA_AND_LOAD_MANUAL";
export const MACHINE_GET_DIALOG_AND_CONTINUE = "MACHINE_GET_DIALOG_AND_CONTINUE";
export const MACHINE_GET_DIALOG_AND_SKIP_BARCODE = "MACHINE_GET_DIALOG_AND_SKIP_BARCODE";
export const GET_PACKAGES_FOR_COLORANT_WITH_IMAGE = "GET_PACKAGES_FOR_COLORANT_WITH_IMAGE";
export const SPECTRO_SELECTION_TEST = "SPECTRO_SELECTION_TEST";
export const SPECTRO_SELECTION_MANUAL_TEST = "SPECTRO_SELECTION_MANUAL_TEST";
export const SPECTRO_CONNECTION_TEST = "SPECTRO_CONNECTION_TEST";
export const PREPARE_FILE_BACKUP_LOCAL_DB = "PREPARE_FILE_BACKUP_LOCAL_DB";
export const PREPARE_FILE_PRICING_DATA = "PREPARE_FILE_PRICING_DATA";
export const PREPARE_FILE_STATS_DATA = "PREPARE_FILE_STATS_DATA";
export const PREPARE_FILE_CHANNEL_ALL_STATS_DATA = "PREPARE_FILE_CHANNEL_ALL_STATS_DATA";
export const PREPARE_FILE_CHANNEL_DISPENSE_STATS_DATA = "PREPARE_FILE_CHANNEL_DISPENSE_STATS_DATA";
export const PREPARE_FILE_CHANNEL_PURGE_STATS_DATA = "PREPARE_FILE_CHANNEL_PURGE_STATS_DATA";
export const MY_ORDERS_GET_DATA_WITH_OFFSET = "MY_ORDERS_GET_DATA_WITH_OFFSET";
export const TO_DISPENSE_GET_ORDERS_WITH_OFFSET = "TO_DISPENSE_GET_ORDERS_WITH_OFFSET";
export const TO_DISPENSE_GET_ORDERS_WITH_NOTIFICATION = "TO_DISPENSE_GET_ORDERS_WITH_NOTIFICATION";
export const TO_DISPENSE_GET_DETAIL = "TO_DISPENSE_GET_DETAIL";
export const MY_ORDERS_GET_DETAIL = "MY_ORDERS_GET_DETAIL";
export const MY_ORDERS_GET_DETAIL_AND_OPEN_MODAL = "MY_ORDERS_GET_DETAIL_AND_OPEN_MODAL";
export const GET_LIGHT_MY_ORDERS_PRODUCT_IMAGE = "GET_LIGHT_MY_ORDERS_PRODUCT_IMAGE";
export const TO_DISPENSE_VALIDATE = "TO_DISPENSE_VALIDATE";
export const TO_DISPENSE_VALIDATE_AND_LOAD_MANUAL = "TO_DISPENSE_VALIDATE_AND_LOAD_MANUAL";
export const TO_DISPENSE_DELETE_ORDER = "TO_DISPENSE_DELETE_ORDER";
export const SET_ORDER_MORE_INFO = "SET_ORDER_MORE_INFO";
export const TO_DISPENSE_SET_ORDER_STATUS_DONE = "TO_DISPENSE_SET_ORDER_STATUS_DONE";
export const ORDERS_HISTORY_GET_ORDERS = "ORDERS_HISTORY_GET_ORDERS";
export const ORDERS_HISTORY_GET_DETAIL = "ORDERS_HISTORY_GET_DETAIL";
export const GET_ORDERS_HISTORY_WITH_OFFSET = "GET_ORDERS_HISTORY_WITH_OFFSET";
export const GET_STATISTICS_WITH_OFFSET = "GET_STATISTICS_WITH_OFFSET";
export const ADD_ORDER_RECORD_AND_CLOSE_MODAL = "ADD_ORDER_RECORD_AND_CLOSE_MODAL";
export const ADD_QUICK_TINT_STATS_DIRECTLY = "ADD_QUICK_TINT_STATS_DIRECTLY";
export const GET_ALL_DATABASES_LIST = "GET_ALL_DATABASES_LIST";
export const GET_ALL_DATABASES_LIST_AND_SKIP_UPDATE = "GET_ALL_DATABASES_LIST_AND_SKIP_UPDATE";
export const GET_ACTIVE_DATABASE_AND_LOG_IN = "GET_ACTIVE_DATABASE_AND_LOG_IN";
export const GET_COMPATIBLE_SERVERS = "GET_COMPATIBLE_SERVERS";
export const GET_COMPATIBLE_SERVERS_AND_OPEN_MODAL = "GET_COMPATIBLE_SERVERS_AND_OPEN_MODAL";
export const LIGHT_LOAD_COMPATIBLE_SERVERS = "LIGHT_LOAD_COMPATIBLE_SERVERS";
export const GET_SERVER_MANAGEMENT_LIST = "GET_SERVER_MANAGEMENT_LIST";
export const GET_ITEM_BY_BARCODE_TEST = "GET_ITEM_BY_BARCODE_TEST";
export const GET_BARCODE_TEST_MODAL_PRODUCT_IMAGE = "GET_BARCODE_TEST_MODAL_PRODUCT_IMAGE";
export const GET_BARCODE_TEST_MODAL_COLORANT_PACKAGE_IMAGE = "GET_BARCODE_TEST_MODAL_COLORANT_PACKAGE_IMAGE";
export const GET_FORMULA_ITEMS_BY_BARCODE = "GET_FORMULA_ITEMS_BY_BARCODE";
export const GET_POS_INFO = "GET_POS_INFO";
export const GET_COLOR_IN_FANDECK = "GET_COLOR_IN_FANDECK";
export const GET_FORMULA_CIF = "GET_FORMULA_CIF";
export const RELOAD_GLOBAL_ALL_PRODUCTS = "RELOAD_GLOBAL_ALL_PRODUCTS";
export const RELOAD_GLOBAL_ALL_PRODUCTS_SIMPLE = "RELOAD_GLOBAL_ALL_PRODUCTS_SIMPLE";
export const RELOAD_GLOBAL_ALL_FANDECKS = "RELOAD_GLOBAL_ALL_FANDECKS";
export const RELOAD_GLOBAL_INITIAL_DATA = "RELOAD_GLOBAL_INITIAL_DATA";
export const RELOAD_GLOBAL_PRICE_SETTINGS = "RELOAD_GLOBAL_PRICE_SETTINGS";
export const RELOAD_GLOBAL_GET_ALL_UNITS = "RELOAD_GLOBAL_GET_ALL_UNITS";

export const GET_LICENSE_REQUEST = "GET_LICENSE_REQUEST";
export const GET_AVAILABLE_LICENSE_PRODUCTS = "GET_AVAILABLE_LICENSE_PRODUCTS";
export const GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED = "GET_AVAILABLE_LICENSE_PRODUCTS_ORDERED";
export const CREATE_LICENSE_REQUEST = "CREATE_LICENSE_REQUEST";
export const REMOVE_LICENSE_REQUEST = "REMOVE_LICENSE_REQUEST";
export const INSTALL_LICENSE = "INSTALL_LICENSE";
export const ONLINE_LICENSE_ACTIVATION_AVAILABLE = "ONLINE_LICENSE_ACTIVATION_AVAILABLE";
export const ONLINE_ACTIVATION_AVAILABLE_FOR_LICENSE_WIZARD = "ONLINE_ACTIVATION_AVAILABLE_FOR_LICENSE_WIZARD";
export const ONLINE_LICENSE_UPDATE = "ONLINE_LICENSE_UPDATE";
export const ONLINE_LICENSE_COUNTS = "ONLINE_LICENSE_COUNTS";
export const ONLINE_LICENSE_ACTIVATE = "ONLINE_LICENSE_ACTIVATE";
export const GET_SERVER_VERSION = "GET_SERVER_VERSION";
export const UPDATE_DATABASES = "UPDATE_DATABASES";
export const GET_LICENSE_INFO = "GET_LICENSE_INFO";
export const SET_CLIENT_IDENTIFIER = "SET_CLIENT_IDENTIFIER";
export const GET_CLIENT_IDENTIFIER = "GET_CLIENT_IDENTIFIER";
export const INSTALL_DATABASE_FILE_EXCEL = "INSTALL_DATABASE_FILE_EXCEL";
export const INSTALL_DATABASE_FILE_EXE = "INSTALL_DATABASE_FILE_EXE";
export const INSTALL_DATABASE_FILE_ZIP = "INSTALL_DATABASE_FILE_ZIP";
export const GET_DISABLED_PRODUCTS_STATUS = "GET_DISABLED_PRODUCTS_STATUS";
export const GET_DISABLED_FANDECKS_STATUS = "GET_DISABLED_FANDECKS_STATUS";

export const GET_LOGGED_USER = "GET_LOGGED_USER";
export const GET_LOGGED_DATABASE_USER = "GET_LOGGED_DATABASE_USER";
export const LOG_IN = "LOG_IN";
export const LOG_OUT = "LOG_OUT";
export const VALIDATE_USER_PASSWORD = "VALIDATE_USER_PASSWORD";
export const VALIDATE_USER_PASSWORD_AUTHENTICATION = "VALIDATE_USER_PASSWORD_AUTHENTICATION";

export const RELOAD_LAST_DISPENSED_FORMULAS = "RELOAD_LAST_DISPENSED_FORMULAS";
export const GET_ALL_FAVORITE_FORMULAS = "GET_ALL_FAVORITE_FORMULAS";
export const RELOAD_ALL_COLORANTS = "RELOAD_ALL_COLORANTS";
export const RELOAD_ALL_SERVER_COLORANTS = "RELOAD_ALL_SERVER_COLORANTS";
export const GET_ALL_CUSTOM_FANDECKS = "GET_ALL_CUSTOM_FANDECKS";
export const GET_ALL_USERS = "GET_ALL_USERS";
export const GET_ALL_USERS_AND_AUTOLOGIN = "GET_ALL_USERS_AND_AUTOLOGIN";
export const GET_ALL_USER_GROUPS = "GET_ALL_USER_GROUPS";
export const GET_SELECTED_USER_GROUPS = "GET_SELECTED_USER_GROUPS";
export const GET_ALL_CUSTOMERS = "GET_ALL_CUSTOMERS";
export const SEARCH_GLOBAL_FORMULAS = "SEARCH_GLOBAL_FORMULAS";
export const GET_COLOR_IMAGE = "GET_COLOR_IMAGE";
export const GET_PRODUCT_IMAGE = "GET_PRODUCT_IMAGE";
export const GET_COLORANT_PACKAGE_IMAGE = "GET_COLORANT_PACKAGE_IMAGE";
export const GET_ALL_PROTOCOLS = "GET_ALL_PROTOCOLS";
export const GET_ALL_IN_FORMATS = "GET_ALL_IN_FORMATS";
export const GET_ALL_OUT_FORMATS = "GET_ALL_OUT_FORMATS";
export const TEST_PROTOCOL = "TEST_PROTOCOL";
export const ENABLE_PRODUCT = "ENABLE_PRODUCT";
export const ENABLE_FANDECK = "ENABLE_FANDECK";
export const GET_ALL_TINTOMETRIC_SYSTEMS = "GET_ALL_TINTOMETRIC_SYSTEMS";
export const GET_ACTIVE_TINTOMETRIC_SYSTEM = "GET_ACTIVE_TINTOMETRIC_SYSTEM";
export const GET_TINTOMETRIC_SYSTEM_ICON = "GET_TINTOMETRIC_SYSTEM_ICON";

export const RELOAD_USER_SETTINGS = "RELOAD_USER_SETTINGS";
export const EXPORT_SETTINGS = "EXPORT_SETTINGS";
export const IMPORT_SETTINGS = "IMPORT_SETTINGS";
export const RESTORE_SETTINGS = "RESTORE_SETTINGS";
export const EXPORT_STATIC_SQL = "EXPORT_STATIC_SQL";
export const EXPORT_LOCAL_DB = "EXPORT_LOCAL_DB";
export const EXPORT_LOCAL_FILE = "EXPORT_LOCAL_FILE";

export const BROWSE_CIF = "BROWSE_CIF";
export const GENERATE_FANDECK_PREVIEW = "GENERATE_FANDECK_PREVIEW";
export const GET_ALL_COLORANTS_FOR_BIP = "GET_ALL_COLORANTS_FOR_BIP";
export const GET_AVAILABLE_FORMULAS = "GET_AVAILABLE_FORMULAS";
export const GET_BUILDING_SITES = "GET_BUILDING_SITES";
export const GET_BUILDING_SITES_WITH_OFFSET = "GET_BUILDING_SITES_WITH_OFFSET";
export const GET_CALCULATED_FORMULA = "GET_CALCULATED_FORMULA";
export const GET_CALCULATED_FORMULA_FOR_COLOR_SEARCH = "GET_CALCULATED_FORMULA_FOR_COLOR_SEARCH";
export const GET_CLOSEST_COLOR = "GET_CLOSEST_COLOR";
export const GET_CLOSEST_COLOR_FOR_MISSING_FORMULA = "GET_CLOSEST_COLOR_FOR_MISSING_FORMULA";
export const GET_CLOSEST_COLOR_WITH_PRICES = "GET_CLOSEST_COLOR_WITH_PRICES";
export const GET_COLORS_BY_PARAMS = "GET_COLORS_BY_PARAMS";
export const GET_CUSTOM_FORMULA = "GET_CUSTOM_FORMULA";
export const GET_CUSTOMERS_BY_PARAMS = "GET_CUSTOMERS_BY_PARAMS";
export const GET_FANDECKS_BY_PARAMS = "GET_FANDECKS_BY_PARAMS";
export const GET_FILE_AND_EXPORT = "GET_FILE_AND_EXPORT";
export const GET_FILE_PAGE_PREVIEW = "GET_FILE_PAGE_PREVIEW";
export const GET_FORMULA_CIF_DATA = "GET_FORMULA_CIF_DATA";
export const GET_FORMULA_META_AND_PRINT_DATA = "GET_FORMULA_META_AND_PRINT_DATA";
export const GET_FORMULA_META_AND_PRINT_DATA_WITH_UFI = "GET_FORMULA_META_AND_PRINT_DATA_WITH_UFI";
export const GET_FORMULA_NOTE_IMAGE = "GET_FORMULA_NOTE_IMAGE";
export const GET_FORMULA_VALIDATION_ERRORS = "GET_FORMULA_VALIDATION_ERRORS";
export const GET_LAST_CUSTOMERS = "GET_LAST_CUSTOMERS";
export const GET_PRODUCTS_BY_PARAMS = "GET_PRODUCTS_BY_PARAMS";
export const INIT_FILE_PREVIEW = "INIT_FILE_PREVIEW";
export const LOAD_TICKET_FORMULA = "LOAD_TICKET_FORMULA";
export const RECALCULATE_FORMULA = "RECALCULATE_FORMULA";
export const RECALCULATE_MODIFIED_FORMULA = "RECALCULATE_MODIFIED_FORMULA";
export const RELOAD_CLOSEST_COLOR_WITH_PRICES = "RELOAD_CLOSEST_COLOR_WITH_PRICES";
export const UNLOCK_COMPUTER = "UNLOCK_COMPUTER";

export const GET_CUSTOMER_DETAIL = "GET_CUSTOMER_DETAIL";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const EDIT_CUSTOMER = "EDIT_CUSTOMER";
export const DELETE_CUSTOMER = "DELETE_CUSTOMER";
export const CUSTOMERS_TAB_GET_DETAIL = "CUSTOMERS_TAB_GET_DETAIL";
export const GET_CUSTOMER_BY_EMAIL = "GET_CUSTOMER_BY_EMAIL";

export const GET_ALL_CURRENCIES = "GET_ALL_CURRENCIES";
export const SET_CURRENCY = "SET_CURRENCY";
export const GET_CURRENCY = "GET_CURRENCY";
export const EDIT_CURRENCY = "EDIT_CURRENCY";
export const DELETE_CURRENCY = "DELETE_CURRENCY";
export const ADD_CURRENCY = "ADD_CURRENCY";

export const ADD_FAVORITE_FORMULA = "ADD_FAVORITE_FORMULA";
export const REMOVE_FAVORITE_FORMULA = "REMOVE_FAVORITE_FORMULA";
export const ADD_FAVORITE_FOLDER = "ADD_FAVORITE_FOLDER";
export const EDIT_FAVORITE_FOLDER = "EDIT_FAVORITE_FOLDER";
export const REMOVE_FAVORITE_FOLDER = "REMOVE_FAVORITE_FOLDER";
export const MOVE_FAVORITE_FORMULA = "MOVE_FAVORITE_FORMULA";

export const ADD_CUSTOM_FANDECK = "ADD_CUSTOM_FANDECK";
export const ADD_CUSTOM_FANDECK_AND_ADD_CUSTOM_FORMULA = "ADD_CUSTOM_FANDECK_AND_ADD_CUSTOM_FORMULA";
export const ADD_CUSTOM_FORMULA = "ADD_CUSTOM_FORMULA";
export const ADD_CUSTOM_FORMULA_FROM_XML = "ADD_CUSTOM_FORMULA_FROM_XML";
export const DELETE_CUSTOM_COLOR = "DELETE_CUSTOM_COLOR";
export const EDIT_CUSTOM_FANDECK = "EDIT_CUSTOM_FANDECK";
export const CHECK_AND_ADD_CUSTOM_FORMULA = "CHECK_AND_ADD_CUSTOM_FORMULA";
export const CHECK_CUSTOM_CIF_AND_ADD_CUSTOM_FORMULA = "CHECK_CUSTOM_CIF_AND_ADD_CUSTOM_FORMULA";
export const CHECK_AND_ADD_CUSTOM_FORMULA_FROM_XML = "CHECK_AND_ADD_CUSTOM_FORMULA_FROM_XML";
export const REMOVE_CUSTOM_FANDECK = "REMOVE_CUSTOM_FANDECK";

export const GET_BASE_IN_PRODUCT_PACKAGE_BARCODES = "GET_BASE_IN_PRODUCT_PACKAGE_BARCODES";
export const VALIDATE_BASE_IN_PRODUCT_PACKAGE_BARCODE = "VALIDATE_BASE_IN_PRODUCT_PACKAGE_BARCODE";

export const GET_BATCHES_BY_COLORANT = "GET_BATCHES_BY_COLORANT";
export const GET_ALL_COLORANT_BATCHES = "GET_ALL_COLORANT_BATCHES";
export const RELOAD_MACHINE_CAN_BATCH_NUMBERS = "RELOAD_MACHINE_CAN_BATCH_NUMBERS";

export const RCC_GET_VERSION = "RCC_GET_VERSION";
export const MACHINE_IS_SELECTED = "MACHINE_IS_SELECTED";
export const MACHINE_IS_CONNECTING = "MACHINE_IS_CONNECTING";
export const MACHINE_IS_CONNECTED = "MACHINE_IS_CONNECTED";
export const MACHINE_START_CONNECT = "MACHINE_START_CONNECT";
export const MACHINE_START_DISCONNECT = "MACHINE_START_DISCONNECT";
export const GET_DRIVER_CONFIGURATION = "GET_DRIVER_CONFIGURATION";
export const SET_DRIVER_CONFIGURATION = "SET_DRIVER_CONFIGURATION";
export const MACHINE_GET_CONFIGURATION = "MACHINE_GET_CONFIGURATION";
export const GET_DRIVER_TYPES = "GET_DRIVER_TYPES";
export const GET_SPECTRO_CONFIGURATION = "GET_SPECTRO_CONFIGURATION";
export const SET_SPECTRO_CONFIGURATION = "SET_SPECTRO_CONFIGURATION";
export const MACHINE_SET_CONFIGURATION = "MACHINE_SET_CONFIGURATION";
export const GET_SPECTRO_TYPES = "GET_SPECTRO_TYPES";
export const GET_SPECTRO_XRITE_MODELS = "GET_SPECTRO_XRITE_MODELS";
export const GET_SPECTRO_COM_PORTS = "GET_SPECTRO_COM_PORTS";
export const MACHINE_GET_CALLS = "MACHINE_GET_CALLS";
export const MACHINE_CANISTERS = "MACHINE_CANISTERS";
export const MACHINE_START_INITIALIZE = "MACHINE_START_INITIALIZE";
export const MACHINE_START_RESET = "MACHINE_START_RESET";
export const MACHINE_START_HARD_RESET = "MACHINE_START_HARD_RESET";
export const MACHINE_START_ERRORS_RESET = "MACHINE_START_ERRORS_RESET";
export const MACHINE_GET_ERRORS = "MACHINE_GET_ERRORS";
export const MACHINE_GET_ERROR_DETAILS = "MACHINE_GET_ERROR_DETAILS";
export const MACHINE_GET_ERROR_IMAGE = "MACHINE_GET_ERROR_IMAGE";
export const MACHINE_GET_CANISTER_IMAGE = "MACHINE_GET_CANISTER_IMAGE";
export const MACHINE_SET_CANISTER_BARCODE = "MACHINE_SET_CANISTER_BARCODE";
export const MACHINE_SET_CANISTER_THRESHOLD = "MACHINE_SET_CANISTER_THRESHOLD";
export const MACHINE_VALIDATE_FORMULA = "MACHINE_VALIDATE_FORMULA";
export const MACHINE_MANUAL_FORMULA = "MACHINE_MANUAL_FORMULA";
export const MACHINE_MANUAL_FORMULA_MY_ORDERS = "MACHINE_MANUAL_FORMULA_MY_ORDERS";
export const MACHINE_MANUAL_FORMULA_TO_DISPENSE = "MACHINE_MANUAL_FORMULA_TO_DISPENSE";
export const MACHINE_START_DISPENSE_FORMULA = "MACHINE_START_DISPENSE_FORMULA";
export const MACHINE_GET_DIALOG = "MACHINE_GET_DIALOG";
export const MACHINE_DIALOG_BUTTON_CLICK = "MACHINE_DIALOG_BUTTON_CLICK";
export const MACHINE_MOVE_TABLE_TO_REFILL = "MACHINE_MOVE_TABLE_TO_REFILL";
export const MACHINE_ADD_CANISTER_LEVEL = "MACHINE_ADD_CANISTER_LEVEL";
export const MACHINE_SET_CANISTER_LEVEL = "MACHINE_SET_CANISTER_LEVEL";
export const MACHINE_SET_MAX_DISPENSE_LEVEL = "MACHINE_SET_MAX_DISPENSE_LEVEL";
export const MACHINE_SET_CANISTER_DISPENSE_LOGIC_TYPE = "MACHINE_SET_CANISTER_DISPENSE_LOGIC_TYPE";
export const MACHINE_START_CANISTER_REFILL = "MACHINE_START_CANISTER_REFILL";
export const MACHINE_START_SHELF = "MACHINE_START_SHELF";
export const MACHINE_START_PUNCH = "MACHINE_START_PUNCH";
export const MACHINE_START_PLUG = "MACHINE_START_PLUG";
export const MACHINE_START_CAP = "MACHINE_START_CAP";
export const MACHINE_SHOW_SERVICE_WINDOW = "MACHINE_SHOW_SERVICE_WINDOW";
export const MACHINE_START_CLEAN_CHANNELS = "MACHINE_START_CLEAN_CHANNELS";
export const MACHINE_START_CLEAN_ALL = "MACHINE_START_CLEAN_ALL";
export const MACHINE_START_RECIRCULATE_CHANNELS = "MACHINE_START_RECIRCULATE_CHANNELS";
export const MACHINE_START_RECIRCULATE_ALL = "MACHINE_START_RECIRCULATE_ALL";
export const MACHINE_START_STIR_CANISTERS = "MACHINE_START_STIR_CANISTERS";
export const MACHINE_START_STIR_ALL = "MACHINE_START_STIR_ALL";
export const MACHINE_START_PURGE = "MACHINE_START_PURGE";
export const MACHINE_START_PURGE_ALL = "MACHINE_START_PURGE_ALL";
export const MACHINE_START_SMART_PURGE = "MACHINE_START_SMART_PURGE";
export const MACHINE_START_SMART_PURGE_ALL = "MACHINE_START_SMART_PURGE_ALL";
export const MACHINE_HISTORY_ACTIONS = "MACHINE_HISTORY_ACTIONS";
export const MACHINE_HISTORY_REFILLS = "MACHINE_HISTORY_REFILLS";
export const MACHINE_GET_CANISTER_BY_BARCODE = "MACHINE_GET_CANISTER_BY_BARCODE";
export const MACHINE_GET_CANISTER_BY_BARCODE_TEST = "MACHINE_GET_CANISTER_BY_BARCODE_TEST";
export const MACHINE_GET_PURGE_STATS = "MACHINE_GET_PURGE_STATS";
export const MACHINE_GET_DISPENSE_STATS = "MACHINE_GET_DISPENSE_STATS";
export const MACHINE_GET_ALL_STATS = "MACHINE_GET_ALL_STATS";
export const MACHINE_GET_UFI_CODES = "MACHINE_GET_UFI_CODES";

export const MACHINE_PURGE_RULES_LIST = "MACHINE_PURGE_RULES_LIST";
export const MACHINE_PURGE_RULE_ADD = "MACHINE_PURGE_RULE_ADD";
export const MACHINE_PURGE_RULE_UPDATE = "MACHINE_PURGE_RULE_UPDATE";

export const MACHINE_GET_AUTOTASKS = "MACHINE_GET_AUTOTASKS";
export const MACHINE_START_AUTOTASK = "MACHINE_START_AUTOTASK";
export const MACHINE_AUTOTASK_DELETE = "MACHINE_AUTOTASK_DELETE";
export const MACHINE_AUTOTASK_ADD_GENERIC = "MACHINE_AUTOTASK_ADD_GENERIC";
export const MACHINE_AUTOTASK_UPDATE_GENERIC = "MACHINE_AUTOTASK_UPDATE_GENERIC";
export const GET_PACKAGES_FOR_COLORANT = "GET_PACKAGES_FOR_COLORANT";
export const MACHINE_SET_CANISTER_UFI_CODE = "MACHINE_SET_CANISTER_UFI_CODE";

export const MACHINE_BACKUP_CONFIGURATION = "MACHINE_BACKUP_CONFIGURATION";

export const SPECTRO_IS_SELECTED = "SPECTRO_IS_SELECTED";
export const SPECTRO_IS_CONNECTED = "SPECTRO_IS_CONNECTED";
export const SPECTRO_IS_CALIBRATED = "SPECTRO_IS_CALIBRATED";
export const SPECTRO_START_CONNECT = "SPECTRO_START_CONNECT";
export const SPECTRO_GET_CALLS = "SPECTRO_GET_CALLS";
export const SPECTRO_GET_INFO = "SPECTRO_GET_INFO";
export const SPECTRO_GET_DIALOG = "SPECTRO_GET_DIALOG";
export const SPECTRO_GET_DIALOG_AND_START_MEASURE = "SPECTRO_GET_DIALOG_AND_START_MEASURE";
export const SPECTRO_DIALOG_BUTTON_CLICK = "SPECTRO_DIALOG_BUTTON_CLICK";
export const SPECTRO_START_CALIBRATE = "SPECTRO_START_CALIBRATE";
export const SPECTRO_START_MEASURE = "SPECTRO_START_MEASURE";
export const SPECTRO_START_DISCONNECT = "SPECTRO_START_DISCONNECT";

export const GET_COLORS_BY_SPECTRO_DELTA = "GET_COLORS_BY_SPECTRO_DELTA";

export const RCC_PRINT_FORMULA_SILENT = "RCC_PRINT_FORMULA_SILENT";

// Pricing
export const PRICING_GET_GENERIC_DATA = "PRICING_GET_GENERIC_DATA";
export const PRICING_SET_GENERIC_DATA = "PRICING_SET_GENERIC_DATA";
export const PRICING_GET_GENERIC_COLORANT_DATA = "PRICING_GET_GENERIC_COLORANT_DATA";
export const PRICING_SET_GENERIC_COLORANT_DATA = "PRICING_SET_GENERIC_COLORANT_DATA";
export const PRICING_GET_GENERIC_PACKAGE_DATA = "PRICING_GET_GENERIC_PACKAGE_DATA";
export const PRICING_SET_GENERIC_PACKAGE_DATA = "PRICING_SET_GENERIC_PACKAGE_DATA";
export const PRICING_GET_GENERIC_PRODUCT_DATA = "PRICING_GET_GENERIC_PRODUCT_DATA";
export const PRICING_SET_GENERIC_PRODUCT_DATA = "PRICING_SET_GENERIC_PRODUCT_DATA";
export const PRICING_GET_COLORANTS_DATA = "PRICING_GET_COLORANTS_DATA";
export const PRICING_SET_COLORANT_DATA = "PRICING_SET_COLORANT_DATA";
export const PRICING_SET_COLORANT_MARGIN_DATA = "PRICING_SET_COLORANT_MARGIN_DATA";
export const PRICING_GET_PACKAGES_DATA = "PRICING_GET_PACKAGES_DATA";
export const PRICING_SET_PACKAGE_DATA = "PRICING_SET_PACKAGE_DATA";
export const PRICING_GET_BASE_IN_PRODUCTS_DATA = "PRICING_GET_BASE_IN_PRODUCTS_DATA";
export const PRICING_SET_BASE_IN_PRODUCT_DATA = "PRICING_SET_BASE_IN_PRODUCT_DATA";
export const PRICING_SET_BASE_IN_PRODUCT_MARGIN_DATA = "PRICING_SET_BASE_IN_PRODUCT_MARGIN_DATA";
export const PRICING_SET_BASE_IN_PRODUCT_PACKAGE_DATA = "PRICING_SET_BASE_IN_PRODUCT_PACKAGE_DATA";
export const PRICING_SET_BASE_IN_PRODUCT_PACKAGE_MARGIN_DATA = "PRICING_SET_BASE_IN_PRODUCT_PACKAGE_MARGIN_DATA";
export const PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA = "PRICING_GET_BASE_IN_PRODUCTS_AND_PACKAGES_DATA";
export const PRICING_IMPORT_DATA = "PRICING_IMPORT_DATA";

// Pricing settings
export const INIT_GLOBAL_PRICE_SETTINGS = "INIT_PRICE_SETTINGS";
export const PRICING_SET_PRICE_DEFINITION = "PRICING_SET_PRICE_DEFINITION";
export const PRICING_GET_PRICE_DEFINITION = "PRICING_GET_PRICE_DEFINITION";
export const PRICING_SET_PRICE_UNIT_DEFINITION = "PRICING_SET_PRICE_UNIT_DEFINITION";
export const PRICING_GET_PRICE_UNIT_DEFINITION = "PRICING_GET_PRICE_UNIT_DEFINITION";
export const PRICING_SET_PRICE_GROUP_NUMBER = "PRICING_SET_PRICE_GROUP_NUMBER";
export const PRICING_GET_PRICE_GROUP_NUMBER = "PRICING_GET_PRICE_GROUP_NUMBER";
export const PRICING_SET_PRICE_GROUPS = "PRICING_SET_PRICE_GROUPS";
export const PRICING_GET_PRICE_GROUPS = "PRICING_GET_PRICE_GROUPS";
export const PRICING_SET_SETTING_LOCAL_PRICES = "PRICING_SET_SETTING_LOCAL_PRICES";
export const PRICING_GET_SETTING_LOCAL_PRICES = "PRICING_GET_SETTING_LOCAL_PRICES";
export const PRICING_SET_SETTING_MARGIN = "PRICING_SET_SETTING_MARGIN";
export const PRICING_SET_SETTING_MARKUP = "PRICING_SET_SETTING_MARKUP";
export const PRICING_SET_SETTING_DISCOUNT = "PRICING_SET_SETTING_DISCOUNT";
export const PRICING_GET_SETTING_MARGIN = "PRICING_GET_SETTING_MARGIN";
export const PRICING_GET_SETTING_MARKUP = "PRICING_GET_SETTING_MARKUP";
export const PRICING_GET_SETTING_DISCOUNT = "PRICING_GET_SETTING_DISCOUNT";

//Download files
export const PREPARE_FILE_BYTES = "PREPARE_FILE_BYTES";
export const RELEASE_PREPARED_FILE = "RELEASE_PREPARED_FILE";

// Margin settings
export const GET_ALL_MARGINS = "GET_ALL_MARGINS";
export const ADD_MARGIN = "ADD_MARGIN";
export const EDIT_MARGIN = "EDIT_MARGIN";
export const REMOVE_MARGIN = "REMOVE_MARGIN";
export const MOVE_UP_MARGIN = "MOVE_UP_MARGIN";
export const MOVE_DOWN_MARGIN = "MOVE_DOWN_MARGIN";

// User settings
export const ADD_USER = "ADD_USER";
export const DELETE_USER = "DELETE_USER";
export const RESTORE_USER = "RESTORE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const ADD_USER_INTO_GROUP = "ADD_USER_INTO_GROUP";
export const REMOVE_USER_FROM_GROUP = "REMOVE_USER_FROM_GROUP";
export const REMOVE_USER_FROM_ALL_GROUPS = "REMOVE_USER_FROM_ALL_GROUPS";
export const CHANGE_USER_PASSWORD = "CHANGE_USER_PASSWORD";

export const MY_ORDERS_GET_DATA = "MY_ORDERS_GET_DATA";
export const TO_DISPENSE_GET_ORDERS = "TO_DISPENSE_GET_ORDERS";
export const ASSIGN_ORDER = "ASSIGN_ORDER";
export const RELEASE_ORDER = "RELEASE_ORDER";

export const GET_STATISTICS = "GET_STATISTICS";
export const GET_FORMULA_DATA_FROM_STATS = "GET_FORMULA_DATA_FROM_STATS";
export const GET_FORMULA_META_DATA_FROM_STATS = "GET_FORMULA_META_DATA_FROM_STATS";
export const SET_STATISTIC_HIDDEN = "SET_STATISTIC_HIDDEN";
export const SET_STATISTIC_MORE_INFO = "SET_STATISTIC_MORE_INFO";
export const SET_STATISTIC_COLOR_DIFFERENCE = "SET_STATISTIC_COLOR_DIFFERENCE";
export const EXPORT_STATISTICS_HISTORY = "EXPORT_STATISTICS_HISTORY";

export const GET_DIFFERENCE_DETAIL = "GET_DIFFERENCE_DETAIL";

export const ADD_QUICK_TINT_INTO_STATISTICS = "ADD_QUICK_TINT_INTO_STATISTICS";
export const ADD_COLOR_STATS = "ADD_COLOR_STATS";
export const ADD_COLOR_STATS_CORRECTION = "ADD_COLOR_STATS_CORRECTION";
export const ADD_COLOR_STATS_FROM_ORDER = "ADD_COLOR_STATS_FROM_ORDER";
export const ADD_COLOR_STATS_FROM_STATS = "ADD_COLOR_STATS_FROM_STATS";
export const ADD_COLOR_STATS_DIRECTLY = "ADD_COLOR_STATS_DIRECTLY";
export const GET_CORRECTION_HISTORY = "GET_CORRECTION_HISTORY";
export const ADD_COLOR_STATS_FROM_ORDER_DIRECTLY = "ADD_COLOR_STATS_FROM_ORDER_DIRECTLY";
export const ADD_DISPENSED_PACKAGE = "ADD_DISPENSED_PACKAGE";
export const FINISH_DISPENSED_PACKAGE = "FINISH_DISPENSED_PACKAGE";
export const ADD_ORDER_RECORD = "ADD_ORDER_RECORD";
export const ADD_AND_FINISH_ALL_DISPENSED_PACKAGE = "ADD_AND_FINISH_ALL_DISPENSED_PACKAGE";

export const GET_DATABASES_LIST = "GET_DATABASES_LIST";
export const GET_DATABASES_READY_FOR_PARTIAL_UPDATES = "GET_DATABASES_READY_FOR_PARTIAL_UPDATES";
export const GET_ACTIVE_DATABASE = "GET_ACTIVE_DATABASE";
export const SET_ACTIVE_DATABASE = "SET_ACTIVE_DATABASE";
export const GET_DATABASE_IMAGE = "GET_DATABASE_IMAGE";
export const ADD_SERVER = "ADD_SERVER";
export const EDIT_SERVER = "EDIT_SERVER";
export const DELETE_REDLIKE_SERVERS = "DELETE_REDLIKE_SERVERS";

export const GET_ITEM_BY_BARCODE = "GET_ITEM_BY_BARCODE";
export const GET_BARCODE = "GET_BARCODE";
export const GET_BARCODE_AND_OPEN_MODAL = "GET_BARCODE_AND_OPEN_MODAL";

export const SET_REGISTRATION_DATA = "SET_REGISTRATION_DATA";
export const GET_REGISTRATION_DATA = "GET_REGISTRATION_DATA";

export const PRINTER_GET_DEFAULT = "PRINTER_GET_DEFAULT";
export const PRINTER_GET_TEMPLATES_LIST = "PRINTER_GET_TEMPLATES_LIST";
export const PRINTER_START_JPG_EXPORT = "PRINTER_START_JPG_EXPORT";
export const PRINTER_START_PDF_EXPORT = "PRINTER_START_PDF_EXPORT";

export const SUPPORTED_IMPORT_CUSTOM_DATA_FORMATS = "SUPPORTED_IMPORT_CUSTOM_DATA_FORMATS";
export const IMPORT_CUSTOM_DATA = "IMPORT_CUSTOM_DATA";
export const ABORT_CUSTOM_DATA_IMPORTING = "ABORT_CUSTOM_DATA_IMPORTING";
export const DELETE_IMPORTED_CUSTOM_DATA = "DELETE_IMPORTED_CUSTOM_DATA";

// Ticketing methods
export const CREATE_TICKET = "CREATE_TICKET";
export const DELETE_TICKET = "DELETE_TICKET";
export const GET_TICKETS = "GET_TICKETS";
export const GET_SERVICE_DEPARTMENTS = "GET_SERVICE_DEPARTMENTS";
export const MARK_TICKET_AS_READ = "MARK_TICKET_AS_READ";
export const TICKETING_GET_FANDECK_LIST = "TICKETING_GET_FANDECK_LIST";
export const TICKETING_GET_COLOR_LIST = "TICKETING_GET_COLOR_LIST";
export const TICKETING_GET_PRODUCT_LIST = "TICKETING_GET_PRODUCT_LIST";
export const TICKETING_GET_BASE_LIST = "TICKETING_GET_BASE_LIST";

// TMC
export const GET_TMC_CONNECTION_STATUS = "GET_TMC_CONNECTION_STATUS";

// Helper Server methods
export const HELPER_IS_ONLINE = "HELPER_IS_ONLINE";
export const HELPER_SEND_ERROR_REPORT = "HELPER_SEND_ERROR_REPORT";
export const HELPER_SET_CONFIGURATION = "HELPER_SET_CONFIGURATION";
export const HELPER_SAVE_LOG_FILES = "HELPER_SAVE_LOG_FILES";
export const HELPER_DIALOG_BUTTON_CLICK = "HELPER_DIALOG_BUTTON_CLICK";
export const HELPER_PREPARE_LOG_FILE = "HELPER_PREPARE_LOG_FILE";
export const HELPER_GET_PREPARED_LOG_ARCHIVE = "HELPER_GET_PREPARED_LOG_ARCHIVE";
export const HELPER_RELEASE_LOG_ARCHIVE = "HELPER_RELEASE_LOG_ARCHIVE";
export const HELPER_RESTART_SERVER = "HELPER_RESTART_SERVER";

// Server banners
export const GET_ALL_BANNERS = "GET_ALL_BANNERS";
export const GET_BANNER_IMAGE = "GET_BANNER_IMAGE";

// Stock
export const MACHINE_COLORANT_PREDICTION = "MACHINE_COLORANT_PREDICTION";
export const STOCK_ADD_COLORANT_PACKAGES = "STOCK_ADD_COLORANT_PACKAGES";
export const STOCK_ADD_COLORANT_PACKAGES_ORDER = "STOCK_ADD_COLORANT_PACKAGES_ORDER";
export const STOCK_GET_COLORANT_PACKAGES = "STOCK_GET_COLORANT_PACKAGES";
export const STOCK_REMOVE_COLORANT_PACKAGE = "STOCK_REMOVE_COLORANT_PACKAGE";
export const STOCK_SET_PREDICTION_FOR_COLORANT_PACKAGES = "STOCK_SET_PREDICTION_FOR_COLORANT_PACKAGES";

// Matching
export const MATCHING_INIT = "MATCHING_INIT";
export const MATCHING_CAN_BE_USED = "MATCHING_CAN_BE_USED";
export const MATCHING_GET_PRODUCTS_AVAILABLE_FOR_MATCHING = "MATCHING_GET_PRODUCTS_AVAILABLE_FOR_MATCHING";
export const MATCHING_GET_COLOR_FILES_FOR_PRODUCT = "MATCHING_GET_COLOR_FILES_FOR_PRODUCT";
export const MATCHING_GET_COLORIFILE_DETAIL = "MATCHING_GET_COLORIFILE_DETAIL";
export const MATCHING_GET_PACKAGES = "MATCHING_GET_PACKAGES";
export const MATCHING_GET_RESULT = "MATCHING_GET_RESULT";
export const MATCHING_START_MEASURE = "MATCHING_START_MEASURE";
export const MATCHING_TAB_GET_DETAIL = "MATCHING_TAB_GET_DETAIL";
export const MATCHING_TAB_GET_FANDECK_LIST = "MATCHING_TAB_GET_FANDECK_LIST";
export const MATCHING_TAB_GET_FANDECK_LIST_WITH_OFFSET = "MATCHING_TAB_GET_FANDECK_LIST_WITH_OFFSET";
export const MATCHING_TAB_GET_COLOR_LIST = "MATCHING_TAB_GET_COLOR_LIST";
export const MATCHING_TAB_GET_COLOR_LIST_WITH_OFFSET = "MATCHING_TAB_GET_COLOR_LIST_WITH_OFFSET";
export const CORRECTION_GET_RESULT = "CORRECTION_GET_RESULT";
export const REFORMULATION_GET_RESULT = "REFORMULATION_GET_RESULT";

// Partial updates
export const GET_ALL_PREPARED_UPDATES_PER_DATABASE = "GET_ALL_PREPARED_UPDATES_PER_DATABASE";
export const APPLY_ALL_PREPARED_UPDATES_PER_DATABASE = "APPLY_ALL_PREPARED_UPDATES_PER_DATABASE";
export const GET_PREPARED_PARTIAL_UPDATES_COUNT_AFTER_INIT = "GET_PREPARED_PARTIAL_UPDATES_COUNT_AFTER_INIT";
export const GET_PREPARED_PARTIAL_UPDATES_COUNT = "GET_PREPARED_PARTIAL_UPDATES_COUNT";
